export type TSelectValue = string | string[];

export type TSelectFunction = (value: TSelectValue) => void;

export interface IOption {
    name: string;
    value: string;
}

export interface IPosition {
    left: number;
    top: number;
}

interface IOpenConfig {
    options: IOption[];
    isMultiple: boolean;
    position: IPosition;
    select: TSelectFunction;
    value?: TSelectValue;
}

export default class StupidSelectStore {

    public visible = false;

    public options: IOption[] = [];

    public value?: TSelectValue;

    public position: IPosition = {
        left: 0,
        top: 0
    };

    public isMultiple = false;

    private select?: TSelectFunction;

    constructor(private setState: any) { }

    public open = (options: IOpenConfig) => {
        this.setState({ ...options, visible: true });
    }

    public close = () => {
        this.setState({ visible: false });
    }

    public onSelect = (value: TSelectValue) => {
        if (this.select) {
            this.select(value);
        }
    }

    public setValue = (value: TSelectValue) => {
        this.setState({ ...this, value });
    }
}
